<template>
    <Layout sub="applicants" main="Applications">
        <div class="px-4 sm:px-6 lg:px-8">
            <div class="sm:flex sm:items-center">
                <div class="sm:flex-auto">
                    <h1 class="text-xl font-semibold text-gray-900">
                        Applications
                    </h1>
                    <p class="mt-2 text-sm text-gray-700">
                        A list of applications
                    </p>
                </div>
                <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                    <ApplicationFilter @search="search" />
                </div>
            </div>
            <div class="mt-8 flex flex-col">
                <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div
                        class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8"
                    >
                        <div
                            class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
                        >
                            <table class="min-w-full divide-y divide-gray-300">
                                <thead class="bg-gray-50">
                                    <tr>
                                        <th
                                            scope="col"
                                            class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                        >
                                            Name
                                        </th>
                                        <th
                                            scope="col"
                                            class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                        >
                                            Application Id
                                        </th>
                                        <th
                                            scope="col"
                                            class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                        >
                                            Status
                                        </th>
                                        <th
                                            scope="col"
                                            class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                                        >
                                            ELO
                                        </th>
                                        <th
                                            scope="col"
                                            class="relative py-3.5 pl-3 pr-4 sm:pr-6"
                                        >
                                            <span class="sr-only">Delete</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody
                                    class="divide-y divide-gray-200 bg-white"
                                >
                                    <tr
                                        v-for="person in props.applications
                                            .data"
                                        :key="person.id"
                                    >
                                        <td
                                            class="whitespace-nowrap py-4 pl-4 pr-3 text-sm sm:pl-6"
                                        >
                                            <div class="flex items-center">
                                                <div
                                                    class="h-10 w-10 flex-shrink-0"
                                                >
                                                    <img
                                                        class="h-10 w-10 rounded-full"
                                                        :src="person?.logo"
                                                        alt=""
                                                    />
                                                </div>
                                                <div class="ml-4">
                                                    <div
                                                        class="font-medium text-gray-900"
                                                    >
                                                        {{ person?.name }}
                                                    </div>
                                                    <div class="text-gray-500">
                                                        {{ person?.email }}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td
                                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                                        >
                                            <div class="text-gray-900">
                                                {{ person?.app_id }}
                                            </div>
                                        </td>
                                        <td
                                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                                        >
                                            <span
                                                :class="[
                                                    person.status === 'created'
                                                        ? 'text-gray-800 bg-gray-100'
                                                        : 'text-gray-800 bg-gray-100',
                                                    person.status === 'rejected'
                                                        ? 'bg-red-100 text-red-800'
                                                        : '',
                                                    person.status === 'submitted'
                                                        ? 'bg-yellow-100 text-yellow-800'
                                                        : '',
                                                    person.status === 'completed'
                                                        ? 'bg-green-100 text-green-800'
                                                        : '',
                                                ]"
                                                class="inline-flex rounded-full px-[15px] py-[1px] text-xs font-semibold leading-5"
                                                >{{ person?.status }}</span
                                            >
                                        </td>
                                        <td
                                            class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                                        >
                                            {{ person?.elo }}
                                        </td>
                                        <td
                                            class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
                                        >
                                            <a
                                                href="#"
                                                @click.prevent="
                                                    handleDelete(person)
                                                "
                                                class="text-indigo-600 hover:text-indigo-900"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    aria-hidden="true"
                                                    role="img"
                                                    class="text-red-500"
                                                    width="32"
                                                    height="32"
                                                    preserveAspectRatio="xMidYMid meet"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        fill="currentColor"
                                                        d="M15 16h4v2h-4v-2m0-8h7v2h-7V8m0 4h6v2h-6v-2m-4-2v8H5v-8h6m2-2H3v10a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V8m1-3h-3l-1-1H6L5 5H2v2h12V5Z"
                                                    ></path>
                                                </svg>
                                                <span class="sr-only"
                                                    >, {{ person?.name }}</span
                                                ></a
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <UserPagination
                                @next="next()"
                                @prev="prev()"
                                class="border-b border-gray-200 mb-4"
                                :navs="props.applications?.links"
                                :meta="props.applications?.meta"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script setup>
import Layout from "@/Shared/Layout";
import Swal from "sweetalert2";
import UserPagination from "@/Shared/UserPagination";
import { Inertia } from "@inertiajs/inertia";
import ApplicationFilter from "@/Shared/ApplicationFilter"

const next = () => {
    Inertia.visit(props.applications.links?.next);
};

const search = (query) => {
    Inertia.visit(
        `/applications?query=${query}`
    );
};

const handleDelete = async (item) => {
    try {
        const res = await Swal.fire({
            title: "Are you sure?",
            text: "This application will be removed.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });
        if (res.isConfirmed) {
            const url = `/applications/${item.id}`;
            await axios.delete(url);
            await Swal.fire(
                "Deleted!",
                "The application has been removed.",
                "success"
            );
            Inertia.visit(window.location.href);
        }
        if (res.isDenied) {
            await Swal.fire(
                "Cancelled",
                "The application has not been removed.",
                "error"
            );
        }
    } catch (e) {
        await Swal.fire("Error!", e.message, "error");
    }
};

const prev = () => {
    Inertia.visit(props.people.links?.prev);
};

const props = defineProps({ applications: Array });
</script>
